import { FF_C4C_ENABLE_CONNECT_VIDEO_CONSULT, FF_C4C_VIDEO_CONSULT } from '@/constants/featureFlags';
import { useFeatureFlags } from '@/hooks';
import { useAppStore } from '@/state-management';
import { ConsultationLinkCard } from '@montugroup/clinic-telecom';
import { TelecomWaitingRoomEntryStatus } from '@montugroup/pms-api-contracts';
import { Box, useTheme } from '@mui/material';

interface AmazonConnectCallBarProps {
  consultationId?: number;
  consultationCode?: string;
  waitingRoomStatus?: TelecomWaitingRoomEntryStatus;
  setConsultationStarted: (consultationStarted: boolean) => void;
  consultationStarted?: boolean;
}

export const AmazonConnectCallBar = ({
  consultationId = -1,
  consultationCode,
  waitingRoomStatus = TelecomWaitingRoomEntryStatus.Created,
  consultationStarted,
  setConsultationStarted
}: AmazonConnectCallBarProps) => {
  const theme = useTheme();

  const { flags } = useFeatureFlags();

  const patientId = useAppStore.use.getPatientId()();
  const patientCode = useAppStore.use.getPatientCode()();
  const { firstName, lastName } = useAppStore.use.getPatientBasicInfo()();
  const { phone: patientPhoneNumber } = useAppStore.use.getPatientContactDetails()();

  const isVideoConsult = flags[FF_C4C_VIDEO_CONSULT];
  const isVideoConsultEnabled = flags[FF_C4C_ENABLE_CONNECT_VIDEO_CONSULT];
  const videoConsultEnabled = isVideoConsult && isVideoConsultEnabled;

  if (!videoConsultEnabled) {
    return null;
  }

  return (
    <Box sx={{ mb: theme.spacing(6) }}>
      <ConsultationLinkCard
        consultationStarted={consultationStarted}
        setConsultationStarted={setConsultationStarted}
        patientId={patientId?.toString()}
        patientName={`${firstName} ${lastName}`}
        patientPhoneNumber={patientPhoneNumber ?? undefined}
        patientCode={patientCode ?? undefined}
        consultationId={consultationId}
        consultationCode={consultationCode}
        waitingRoomStatus={waitingRoomStatus}
      />
    </Box>
  );
};
